module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/shop_studiosuns_03-9bbaa939e260b809eaa67f3dee1ec015.png";